import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AppService } from '../../app.service';
import { Article } from '../../models/article';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgZone } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-article-detail',
  standalone: true,
  imports: [CommonModule, RouterModule, DateFormatPipe],
  template: `
    <div class="">
      @if (isLoading) {
        <div class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      } @else if (article) {
        <div class="">
          <div class="">
            <article>
                <!-- black background on top of image -->
            <div class="main-title" style="background-image: url('{{ article.cover_image ? 'https://api.brandripplr.com/storage/v1/object/public/brandripplr/' + article.cover_image : '' }}'); background-size: cover; background-position: center; background-repeat: no-repeat; box-shadow: 0px 0px 24px 0px rgba(black, 0.13);">
                <div style="background-color: rgba(0, 0, 0, 0.5); padding: 5vw 0; height: 400px;" class="d-flex align-items-center justify-content-center">
                <div class="headings">
                    <h1 style="font-size: 40px; line-height: 1.2; font-weight: 600;">{{ article.title }}</h1>
                    <p style="font-size: 18px; line-height: 1.2; font-weight: 600;">{{ article.published_at | dateFormat:'fullDate' }}</p>
                </div>
                </div>
            </div>

              <section class="mb-5 inner-html" [innerHTML]="getSafeHtml(article.content)">
              </section>
              
            </article>
          </div>
        </div>
      } @else {
        <div class="alert alert-danger">Article not found.</div>
      }
    </div>
  `,
  styles: [`
    :host {
      display: block;
      min-height: 100vh;
      background-color: #f8f9fa;
    }
    .main-title {
        padding: 0;
    background-color: #000;
    color:#fff;
    text-align: center;
}
    
    article {
      background: white;
      
    }
  `]
})
export class ArticleDetailComponent implements OnInit {
  article: Article | null = null;
  isLoading = true;
  
  constructor(
    private titleService: Title, 
    private metaService: Meta,
    private route: ActivatedRoute,
    private appService: AppService,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) {
  }
  
  async ngOnInit() {
    try {
        console.log('Fetching articles...');
        const article = await this.appService.getArticle(this.route.snapshot.params['slug']);
        console.log('Article received:', article);
        
        // Run inside NgZone to ensure change detection works
        this.ngZone.run(() => {
          this.article = article || [];
          console.log('Article after assignment:', this.article);
          this.titleService.setTitle(this.article.meta_title ? this.article.meta_title : this.article.title ? this.article.title : '');
          if (this.article.meta_description) {
            this.metaService.updateTag({ 
              name: 'description', 
              content: this.article.meta_description 
            });
          }
          this.isLoading = false;
          this.cdr.markForCheck();
        });
      } catch (error) {
        console.error('Error loading articles:', error);
        this.ngZone.run(() => {
          this.article = null;
          this.isLoading = false;
          this.cdr.markForCheck();
        });
      }
  }
    
  getSafeHtml(html: string | undefined): SafeHtml {
    if (!html) return '';
    // Replace &nbsp; with regular spaces and ensure safe HTML
    const contentWithSpaces = html.replace(/&nbsp;/g, ' ');
    return this.sanitizer.bypassSecurityTrustHtml(contentWithSpaces);
  }
}
